// src/modules/moduleDashboards/components/BuiltDashboard.jsx
// Renders an admin-built dashboard layout: an ordered list of widgets laid out on
// a responsive 24-column grid by each widget's `span`.
import React from 'react';
import { Row, Col, Spin, Empty } from 'antd';
import WidgetCard from './WidgetCard';

// `onRefresh` re-runs the dashboard fetch. Widgets that write (the approvals
// inbox) call it after an action so every card reflects the new state.
export default function BuiltDashboard({ widgets = [], loading, onRefresh }) {
  return (
    <Spin spinning={loading}>
      {widgets.length ? (
        <Row gutter={[16, 16]}>
          {widgets.map((w) => (
            <Col
              key={w.id}
              xs={24}
              sm={w.span >= 24 ? 24 : 12}
              md={Math.max(6, Math.min(24, w.span || 12))}
              lg={Math.max(4, Math.min(24, w.span || 12))}
            >
              <WidgetCard widget={w} onRefresh={onRefresh} />
            </Col>
          ))}
        </Row>
      ) : (
        <Empty style={{ marginTop: 60 }} description="This dashboard has no widgets yet." />
      )}
    </Spin>
  );
}
